import { Box } from '@mui/material';
import { renderComponent } from '../../helpers/component-renderer';

const OrderedList = ({ items }) => (
  <Box>
    <ol>
      {items.map(({ text }, index) => (
        <li key={index}>
          {renderComponent(
            { type: 'typography', variant: 'body1', text },
            index
          )}
        </li>
      ))}
    </ol>
  </Box>
);

export default OrderedList;
